import { useState } from "react";
import { createRoot } from "react-dom/client";
import { AlertDialog, AlertDialogContent, AlertDialogTitle, AlertDialogDescription } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

// Potvrzovací okno ve stylu aplikace místo systémového window.confirm (229):
//   if (!(await ask("Smazat úhradu 1 000 Kč z 7. 9.?"))) return;
// Text do prvního „?" je nadpis, zbytek vysvětlení. Tlačítko se jmenuje podle slovesa
// v nadpisu (Smazat, Odebrat, Naskladnit…); u nevratných akcí je červené.
const VERBS = ["Smazat", "Stornovat", "Odebrat", "Odpojit", "Ukončit", "Zahodit", "Zavřít", "Naskladnit", "Schválit",
  "Přepnout", "Přidat", "Převést", "Znovu otevřít", "Pokračovat"];
const DANGER = /^(Smazat|Stornovat|Odebrat|Odpojit|Ukončit|Zahodit)/;

export function parseAsk(message, opts = {}) {
  const text = String(message || "").replace(/^Opravdu\s+(\S)/, (_, c) => c.toUpperCase());
  const q = text.indexOf("?");
  const title = opts.title || (q >= 0 ? text.slice(0, q + 1) : text);
  const description = opts.description ?? (q >= 0 ? text.slice(q + 1).trim() : "");
  const verb = VERBS.find((v) => title.startsWith(v));
  return {
    title, description,
    ok: opts.ok || (verb === "Zavřít" ? "Zavřít bez uložení" : verb) || "Potvrdit",
    cancel: opts.cancel || "Zpět",
    danger: opts.danger ?? DANGER.test(title),
  };
}

function AskDialog({ cfg, onDone }) {
  const [open, setOpen] = useState(true);
  const finish = (v) => { setOpen(false); onDone(v); };
  return (
    <AlertDialog open={open} onOpenChange={(o) => { if (!o) finish(false); }}>
      <AlertDialogContent className="max-w-[440px] w-[calc(100vw-32px)] rounded-[24px] p-6 gap-0" data-testid="ask-dialog">
        <AlertDialogTitle className="font-heading text-[20px] font-extrabold leading-snug pr-2">{cfg.title}</AlertDialogTitle>
        {cfg.description
          ? <AlertDialogDescription className="text-[15px] leading-relaxed mt-2 whitespace-pre-line">{cfg.description}</AlertDialogDescription>
          : <AlertDialogDescription className="sr-only">Potvrzení akce</AlertDialogDescription>}
        <div className="flex flex-col-reverse md:flex-row md:justify-end gap-2 mt-6">
          <Button variant="outline" onClick={() => finish(false)} className="w-full md:w-auto h-11 rounded-full font-bold px-5" data-testid="ask-cancel">{cfg.cancel}</Button>
          <Button onClick={() => finish(true)} autoFocus data-testid="ask-ok"
            className={`w-full md:w-auto h-11 rounded-full font-bold px-5 ${cfg.danger ? "bg-destructive text-destructive-foreground hover:bg-destructive/90" : ""}`}>{cfg.ok}</Button>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export function ask(message, opts) {
  return new Promise((resolve) => {
    const host = document.createElement("div");
    document.body.appendChild(host);
    const root = createRoot(host);
    let done = false;
    const onDone = (v) => {
      if (done) return;
      done = true;
      resolve(v);
      setTimeout(() => { root.unmount(); host.remove(); }, 250);   // animace zavření doběhne
    };
    root.render(<AskDialog cfg={parseAsk(message, opts)} onDone={onDone} />);
  });
}
